import React from 'react';
import { useTranslation } from 'hooks';

import './success.scss';


type SuccessProps = {
  type: 'signin' | 'signup';
};

export const Success: React.FC<SuccessProps> = ({ type }) => {
    const {t} = useTranslation()
 
  const message = t(`success.${type}.label`) ?? ""
    

  return (
    <div className="success-screen">
      <div className="card">
        <h2>{type === 'signup' ? 'Sign Up Success 🎉' : 'Sign In Success ✅'}</h2>
        <p>{message}</p>
      </div>
    </div>
  );
};

